import { LookupData, SpreadLookupInfo } from '@models/lookup-data';
import { LookupSetup } from '@models/lookup-setup';
import { isEmpty } from '@shared/helpers/arrays';

/**
 * @description Iterate over changes made to `SpreadLookupInfo[]` tables (previousData field) and apply those changes to `LookupSetup[]`
 */
export const curateTables = (infoTables: SpreadLookupInfo[], setupTables: LookupSetup[]): SpreadLookupInfo[] => {
  infoTables.forEach(infoTable => {
    const setupTable = setupTables.find(st => st.Id === infoTable.id);
    infoTable = { ...infoTable, ...curateTable(infoTable, setupTable) };
  });

  return infoTables;
};

const curateTable = (infoTable: SpreadLookupInfo, setupTable: LookupSetup): SpreadLookupInfo => {
  if (infoTable.previousData) {
    const [dim1, dim2, dim3] = infoTable.references;
    const { value: oldValue, index } = infoTable.previousData;

    switch (infoTable.previousData.dimension) {
      case 'results':
        break;

      case 'rows': {
        const newValue = infoTable.rows[index[0]];
        const modifiedTables: LookupData[] = setupTable.Data.filter(st => st[dim1] === oldValue);

        if (isEmpty(newValue)) {
          infoTable.results[index[0]] = [];
          setupTable.Data = setupTable.Data.filter(st => st[dim1] !== oldValue);
        } else {
          modifiedTables.forEach(modifiedTable => {
            modifiedTable[dim1] = newValue;
          });
        }
        break;
      }

      case 'cols': {
        const newValue = infoTable.cols[index[0]];
        const modifiedTables: LookupData[] = setupTable.Data.filter(st => st[dim2] === oldValue);

        if (isEmpty(newValue)) {
          infoTable.results.forEach(result => {
            result[index[0]] = null;
          });

          setupTable.Data = setupTable.Data.filter(st => st[dim2] !== oldValue);
        } else {
          if (modifiedTables.length > 0) {
            modifiedTables.forEach(modifiedTable => {
              modifiedTable[dim2] = newValue;
            });
          }
        }
        break;
      }

      case 'pivots': {
        const newValue = infoTable.thirdDimension;
        const modifiedTables: LookupData[] = setupTable.Data.filter(st => st[dim3] === oldValue);

        if (isEmpty(newValue)) {
          infoTable.cols = [];
          infoTable.rows = [];
          infoTable.results = [];
          infoTable.numberOfColumns = 0;
          infoTable.numberOfRows = 0;
          setupTable.Data = setupTable.Data.filter(st => st[dim3] !== oldValue);
        } else {
          modifiedTables.forEach(modifiedTable => {
            modifiedTable[dim3] = newValue;
          });
        }
        break;
      }
      default:
        // console.log(`💙 Something else was changed`);
        break;
    }
  }
  return infoTable;
};
